module.exports = __webpack_public_path__ + "img/parallax1-1440p.f97dda38.jpg";